import React from "react"
import { Tabs, Tab, useTheme } from "@mui/material"

const SubTabs = ({ tabs, value, setValue, marginLeft = 0 }) => {
  const theme = useTheme()
  const spacing = theme.spacing(marginLeft)
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  return (
    <div style={{ width: "100%", marginLeft: spacing }}>
      <Tabs value={value} onChange={handleChange} variant={"scrollable"}>
        {tabs &&
          tabs.map((item, index) => {
            return (
              <Tab
                sx={{
                  color: theme.palette.default[500]
                }}
                id={`tab-${index}`}
                label={item.label}
                key={index}
              />
            )
          })}
      </Tabs>
    </div>
  )
}
export default SubTabs
